var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgOneTrainCutBracketLandscape(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 225,
    viewBox: "0 0 26 225",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 21L0.5 21L3 21ZM23 5.5C24.3807 5.5 25.5 4.38071 25.5 3C25.5 1.61929 24.3807 0.5 23 0.5V5.5ZM5.5 150L5.5 21L0.5 21L0.5 150H5.5ZM5.5 21C5.5 16.035 5.93164 12.0018 7.1559 9.27348C7.74523 7.96011 8.47217 7.05731 9.33097 6.4713C10.1775 5.89368 11.3326 5.5 13 5.5V0.5C10.5007 0.5 8.32252 1.10632 6.51278 2.3412C4.71534 3.56769 3.46311 5.28989 2.5941 7.22652C0.901696 10.9982 0.5 15.965 0.5 21H5.5ZM13 5.5H23V0.5H13V5.5ZM0.5 190V225H5.5V190H0.5Z",
    fill: "#282D37"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOneTrainCutBracketLandscape);
export default __webpack_public_path__ + "static/media/one_train_cut_bracket_landscape.9c87e8693df0f420a721eedc0a873c7b.svg";
export { ForwardRef as ReactComponent };